module.exports = __webpack_public_path__ + "assets/img/place_directory.27f368c2.png";